import { $sceneMapApi } from '@stores/dataStores';
import type { GeneralID } from '@types';

interface Params {
  ids: string | Set<string>;
  sceneId: GeneralID;
}

export function deleteComponentLayers({ ids, sceneId }: Params) {
  let idSet: Set<string>;
  if (typeof ids === 'string') {
    idSet = new Set([ids]);
  } else {
    idSet = ids;
  }
  $sceneMapApi.updateScene({
    id: sceneId,
    updater: (draft) => {
      // 遍历所有图层的图层控制信息, 如果有目标图层 id 为当前图层 id 的, 则删除
      draft.config.components ??= [];
      const list = draft.config.components.filter((x) => !idSet.has(x.id));
      list.forEach((component) => {
        if (component.layerControl) {
          component.layerControl.data = component.layerControl.data.filter(
            (item) => !idSet.has(item.id)
          );
        }
      });
      draft.config.components = list;

      // 遍历热点, 过滤高级交互设置-图层控制, 清除被删除的图层id
      draft.hotspot?.forEach((hotspot) => {
        if (hotspot.extendAction?.layers) {
          hotspot.extendAction.layers = hotspot.extendAction.layers.filter(
            (x) => !idSet.has(x.id)
          );
        }
      });
    },
  });
}
